import React from 'react';

interface IErrorBoxProps {
    message: string;
}

const ErrorBox = (props: IErrorBoxProps) => {
    return (
        <div className="error-box">
            <h2>Oops something went wrong!</h2>
            <details className="error-box__details">
                <ul>
                    <li>
                        <div>{props.message}</div>
                    </li>
                </ul>
            </details>
        </div>
    );
}

export default ErrorBox;
